import { SET_USER_INFO } from "./../actions/DataCol/userdataAction.js";

const initialState = {
	user: {}
};

export function userReducer(state = initialState, action) {
	switch (action.type) {
		case SET_USER_INFO:
			return { ...state, user: action.payload };

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js